import { useState, useEffect } from 'react';

const TEAM = [
  { id: 'tanush', name: 'Tanush', role: 'Founder · CEO', gradient: ['#ffffff', '#d100a3'],
    statuses: ['architecting the next sprint', 'in a deep-work block', 'reviewing the Q3 plan', 'on a discovery call'] },
  { id: 'jacob', name: 'Jacob', role: 'Project Manager', gradient: ['#cbd5e1', '#7c3aed'],
    statuses: ['triaging the project board', 'on a client kickoff', 'syncing with Tanush', 'replying to inbound'] },
  { id: 'rex', name: 'Rex', role: 'CTO · System Architect', gradient: ['#34d399', '#0ea5e9'],
    statuses: ['drawing infra diagrams', 'reviewing a PR', 'tuning the execution engine', 'deploying to staging'] },
  { id: 'koda', name: 'Koda', role: 'Lead Full-stack Engineer', gradient: ['#f472d0', '#7c3aed'],
    statuses: ['shipping a feature branch', 'rewriting a service in Rust', 'fixing the flaky test', 'reading commits'] },
  { id: 'iris', name: 'Iris', role: 'Lead UI / UX Designer', gradient: ['#a78bfa', '#f472d0'],
    statuses: ['exploring 14 hero variants', 'tuning a gradient', 'in design review', 'reading Refactoring UI'] },
  { id: 'stacy', name: 'Stacy', role: 'Security Engineer', gradient: ['#fb923c', '#ef4444'],
    statuses: ['scanning the perimeter', 'patching CVE-2026-1234', 'on a red-team exercise', 'auditing access logs'] },
  { id: 'vance', name: 'Vance', role: 'Growth & Marketing', gradient: ['#60a5fa', '#3b82f6'],
    statuses: ['drafting the launch plan', 'on a positioning call', 'analyzing funnel data', 'briefing Iris'] },
  { id: 'zara', name: 'Zara', role: 'QA · DevOps', gradient: ['#facc15', '#f59e0b'],
    statuses: ['watching the CI pipeline', 'writing fixtures', 'tightening the container', 'on call'] },
];

const Member = ({ m, statusIdx }) => {
  const grad = `linear-gradient(135deg, ${m.gradient[0]}, ${m.gradient[1]})`;
  return (
    <article className="member">
      <div className="member-avatar" style={{ background: grad }}>
        <span className="member-initial">{m.name[0]}</span>
        <span className="member-shine" />
      </div>
      <div className="member-meta">
        <div className="member-name">{m.name}</div>
        <div className="member-role">{m.role}</div>
        <div className="member-status">
          <span className="member-pulse" />
          <span key={statusIdx} className="member-status-text">
            {m.statuses[statusIdx % m.statuses.length]}
          </span>
        </div>
      </div>
    </article>
  );
};

const TeamRoster = () => {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setTick((v) => v + 1), 3600);
    return () => clearInterval(t);
  }, []);

  return (
    <section className="r-section team" id="team">
      <div className="r-wrap">
        <div className="r-tag r-reveal">The kennel</div>
        <h2 className="r-head r-reveal">
          Eight specialists.<br />
          <span className="r-gtxt">One feral team.</span>
        </h2>
        <p className="r-sub r-reveal r-d1">
          Each member is AI-augmented — purpose-built tooling, deep domain ownership.
          The result: an 8-person team that delivers like a 20-person agency.
        </p>

        <div className="team-grid">
          {TEAM.map((m, i) => (
            <Member key={m.id} m={m} statusIdx={tick + i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamRoster;
